import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
const apiKey = process.env.REACT_APP_AMAZON_APIKEY;
const firebaseConfig = {
  apiKey: apiKey,
  authDomain: "new-clone-72373.firebaseapp.com",
  projectId: "new-clone-72373",
  storageBucket: "new-clone-72373.appspot.com",
  messagingSenderId: "1075992196023",
  appId: "1:1075992196023:web:f59b3bb74871fbb6f86e32",
  measurementId: "G-826ZX2Q349",
};



const firebaseApp = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const db = firebaseApp.firestore();
export { auth, db };